import { tourBackButton, tourCustomButton, tourExitButton, tourNextButton } from '../data/tour-buttons';
import { type TourStepDefinition } from '../data/tour-config';
import { TourService } from '../services/tour/tour.service';

export function getResultsTour(tourService: TourService): TourStepDefinition[] {
  return [
    {
      id: 'resultsTourIntro',
      buttons: [tourExitButton(tourService, 'Skip Tour'), tourNextButton('Start Tour')],
      title: 'Welcome to Your Lab Results!',
      text: "Let's take a quick tour to help you understand your test results.",
    },
    {
      id: 'resultsTourStatusIcon',
      attachTo: {
        element: '#statusIcon0',
        on: 'bottom',
      },
      extraHighlights: ['.status-icon:not(#statusIcon0)'], //highlight all status icons during this step
      scrollTo: false,
      buttons: [tourExitButton(tourService), tourBackButton(), tourNextButton('Next (1 of 3)')],
      title: 'Status Labels',
      text: () =>
        `<div class="flex flex-col gap-10">
            <div class="flex align-start gap-10 fs-14">
              <span
                class="status-badge status-abnormal">
                Abnormal
              </span>
              This result is outside the expected range. Contact your care team if you have questions.
            </div>
            <div class="flex align-start gap-10 fs-14">
              <span
                class="status-badge status-unknown">
                Unknown
              </span>
              No reference range is available. Your provider can help interpret this result.
            </div>
            <div style="background: var(--mat-sys-surface-container); border: 1px solid color-mix(in srgb, var(--mat-sys-outline-variant) 58%, transparent); padding: 4px 8px; border-radius: 4px; display: inline-flex; align-items: center; gap: 4px; border-left: 4px solid var(--mat-sys-primary);">
              <div class="fs-14">Results with no label are within normal range.</div>
            </div>
        </div>`,
    },
    {
      id: 'resultsTourResultDetails',
      attachTo: {
        element: '#patientResult0',
        on: 'bottom',
      },
      scrollTo: false,
      buttons: [tourExitButton(tourService), tourBackButton(), tourNextButton('Next (2 of 3)')],
      title: 'Result Details',
      text: () =>
        `<div class="flex flex-col gap-6">
      <span>Each row shows:</span> 
      <ul>
      <li><strong>Test name</strong> and collection date/time on the left</li>
      <li>Your <strong>result value</strong> in the middle (like "YELLOW", "1.02", or "NEGATIVE")</li>
      <li>Tap any result to see detailed information and reference ranges</li>
      </ul>
      </div>`,
    },
    {
      id: 'resultsTourImportantReminder',
      buttons: [tourBackButton('Back', ['two-row-btn']), tourNextButton('Done (3 of 3)')],
      title: 'Important Reminder',
      text: () =>
        `<div class="flex flex-col gap-10">
        <span><strong>Remember:</strong> Lab results should be interpreted by your healthcare provider in the context of your complete medical history.</span>
        <span>If you see any red exclamation marks or have questions about your results, contact your care team through the portal's messaging feature.</span>
        <span>You can scroll down to view all of your test results.</span>
      </div>`,
    },
    {
      id: 'resultsTourOutro',
      buttons: [tourCustomButton('Got it', 'primary', () => tourService.complete())],
      title: "You're All Set!",
      text: () =>
        `<div class="flex flex-col gap-6">
        <span><strong>You can access this tour again anytime from the user menu.</strong></span>
      </div>`,
    },
  ];
}
